<template>
  <div>
    <a-button class="editable-add-btn" style="margin-bottom: 8px" @click="handleAdd">添加</a-button>
    <a-table bordered :data-source="dataSource" :columns="columns" :rowKey="record => record.id">
      <template slot="name" slot-scope="text, record">
        <div>
          <a-input v-if="editableData[record.id] && isAdd" v-model="editableData[record.id]['name']"
            style="margin: -5px 0" />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="image" slot-scope="text, record">
        <img v-if="text" :src="text" width="100px" />
        <div v-else>
          <img v-if="editableData[record.id]['image']" width="100px" :src="editableData[record.id]['image']" />
          <div v-else>
            <or-upload v-model="editableData[record.id]['image']" mode="image" @input="uploadfile" button-text="上传图片" />
          </div>
        </div>
      </template>
      <template slot="mark" slot-scope="text, record">
        <div>
          <a-input v-if="editableData[record.id] && isAdd" v-model="editableData[record.id]['mark']"
            style="margin: -5px 0" />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="status" slot-scope="text,record">
        <div>
          <a-tag :color="record.status == '1' ? 'green' : 'red'">{{ text == '1' ? '正常' : '异常' }}</a-tag>
        </div>
      </template>
      <template slot="operation" slot-scope="text,record">
        <div class="editable-row-operations">
          <span v-if="isAdd && editableData[record.id]">
            <a @click="save(record.id)">保存</a>
            <a-divider type="vertical" />
            <a @click="cancel(record.id)">取消</a>
          </span>
          <span v-else>
            <a @click="edit(record.id)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm v-if="dataSource.length" title="确定要删除吗?" @confirm="onDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-table>
    <a-modal v-model="visible" title="编辑" @ok="save" @cancel="close">
      <a-form :key="formState.id" ref="formRef" :model="formState" :rules="rules">
        <a-form-item label="名字" name="name">
          <a-input v-model="formState.name" />
        </a-form-item>
        <!-- <a-form-item label="地址" name="image">
          <a-input v-model="formState.image" />
        </a-form-item> -->
        <a-form-item label="地址" name="mark">
          <a-input v-model="formState.mark" />
        </a-form-item>
        <a-form-item label="状态" name="status">
          <a-select ref="select" v-model="formState.status" style="width: 120px" disabled>
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">异常</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { message, ATypographyLink, ATag } from 'ant-design-vue';
import * as moment from 'moment';
import OrUpload from "@/components/upload";
const columns = [{
  title: 'ID',
  dataIndex: 'id',
  scopedSlots: { customRender: 'id' }
}, {
  title: '名字',
  dataIndex: 'name',
  scopedSlots: { customRender: 'name' }
}, /* {
  title: '图片地址',
  dataIndex: 'image',
  width: '300px',
  scopedSlots: { customRender: 'image' }
},  */{
  title: '图片位置',
  dataIndex: 'mark',
  scopedSlots: { customRender: 'mark' }
}, {
  title: '创建时间',
  dataIndex: 'create_time',
  scopedSlots: { customRender: 'create_time' }
}, {
  title: '状态',
  dataIndex: 'status',
  scopedSlots: { customRender: 'status' }
}, {
  title: '操作',
  dataIndex: 'operation',
  scopedSlots: { customRender: 'operation' }
}]
const rules = {
  name: [
    {
      required: true,
      message: '请输入图片名称',
      trigger: 'blur'
    },
  ],
  image: [
    {
      required: true,
      message: '请出入图片地址',
      trigger: 'blur',
    },
  ],
  status: [
    {
      required: true,
      message: '请选择图片状态',
      trigger: 'blur',
    },
  ],
};
export default {
  components: { OrUpload },
  computed: {
    count: function () {
      if (this.dataSource.length > 0) {
        return parseInt(this.dataSource.at(-1).id) + 1
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      dataSource: [],
      editableData: {},
      isAdd: false,
      currentKey: '',
      visible: false,
      labelCol: {
        style: {
          width: '100px'
        }
      },
      formState: {},
      columns,
      rules
    }
  },
  created() {
    this.getAdverList()
  },
  methods: {
    uploadfile() {
      console.log(this.editableData);
    },
    edit(key) {
      console.log(key);
      this.editableData[key] = cloneDeep(this.dataSource.filter(item => key === item.id)[0]);
      this.formState = cloneDeep(this.dataSource.filter(item => key === item.id)[0])
      this.currentKey = key;
      this.visible = true;
    },
    async save() {
      let key = this.currentKey;
      try {
        let res;
        if (this.isAdd) {
          let { name, mark } = this.editableData[key];
          res = await this.$axios.post('/api/AdPosition/add', { data: { name, mark, status: 1 } });
          if (res.code === 200) {
            this.isAdd = false;
            delete this.editableData[key];
          }
        } else {
          let { id, name, pid, image } = this.formState;
          Object.assign(this.dataSource.filter(item => key === item.id)[0], this.formState);
          res = await this.$axios.post('/api/AdPosition/edit', { data: { id, name, pid, image } })
          this.visible = false;
        }
        if (res.code === 200) {
          message.success(res.msg);
        } else {
          message.error(res.msg)
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel(key) {
      delete this.editableData[key];
      this.dataSource = this.dataSource.filter(item => item.id !== key)
    },
    async onDelete(key) {
      try {
        let { id, name, pid, image } = this.dataSource.filter(item => item.id === key)[0];
        let { code, data, msg } = await this.$axios.post('/api/AdPosition/dell', { data: { id, name, pid, image } })
        if (code === 200) {
          message.success(msg)
        } else {
          message.error(msg)
        }
        this.dataSource = this.dataSource.filter(item => item.id !== key);
      } catch (error) {
        console.log(error);
      }
    },
    handleAdd() {
      this.isAdd = true;
      let time = moment().format('YYYY-MM-DD hh-mm-ss');
      const newData = {
        id: `${this.count}`,
        name: ``,
        create_time: time,
        status: 1
      };
      this.currentKey = this.count;
      this.editableData[this.count] = newData;
      this.dataSource.push(newData);
    },
    close() {
      delete this.editableData[this.currentKey];
      this.visible = false;
    },
    async getAdverList() {
      try {
        let { code, data, msg } = await this.$axios.post('/api/AdPosition/list', { data: { mark:'kaiping' } });
        if (code === 200) {
          this.dataSource = data;
          console.log(data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>